function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

const isProduction = process.env.NODE_ENV === 'production'
const isStaging = process.env.NODE_ENV === 'staging'

const config = {
  api: {
    ssl: false,
    domain: 'localhost:8080',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  }
}

const productionConfig = {
  api: {
    ssl: true,
    domain: 'dev.api.reporting.cmdr-ops.com'
  }
}

const stagingConfig = {
  api: {
    ssl: true,
    domain: 'dev.api.reporting.cmdr-ops.com'
  }
}

export default isProduction
  ? mergeDeep(config, productionConfig)
  : isStaging
  ? mergeDeep(config, stagingConfig)
  : config
